import { render, staticRenderFns } from "./TraxUiToggle.vue?vue&type=template&id=72144259"
import script from "./TraxUiToggle.vue?vue&type=script&lang=js"
export * from "./TraxUiToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports